import React from 'react';
import {useTranslation} from 'next-i18next';
import TimeSeries from '@components/Charts/StreamsChart';
import Placeholder from '@components/Placeholder';
import type {StreamData} from '@deezer/next/services/api/Legacy/requests/analytic/types';
import AnalyticCard from '@deezer/next/features/Analytic/components/AnalyticCard';
import type {RangeSelector} from '@components/Charts/StreamsChart/RangeSelectors';
import RangeSelectors from '@components/Charts/StreamsChart/RangeSelectors';
import {Box} from '@tempo/core';

type GlobalStreamsProps = {
	data?: StreamData;
	activeRange: RangeSelector;
	rangeButtons: RangeSelector[];
	onRangeChange: (range: RangeSelector) => void;
	isLoading: boolean;
	isError: boolean;
};

const GlobalStreams = ({
	data,
	activeRange,
	rangeButtons,
	onRangeChange,
	isLoading,
	isError,
}: GlobalStreamsProps) => {
	const {t} = useTranslation('d4c');

	return (
		<AnalyticCard
			hasNoData={
				!data || (data && (!data.nbListeners.length || !data.nbStreams.length))
			}
			data-testid="total-streams-card"
			title={t('analyticshome_title_totalstreamsanduniquelisteners_d4c-web')}
			isLoading={isLoading}
			isError={isError}
			placeholder={<Placeholder />}
			variant="overview"
		>
			<Box p="spacing.l">
				<RangeSelectors
					activeRange={activeRange}
					rangeButtons={rangeButtons}
					onRangeChange={onRangeChange}
				/>
				{data && <TimeSeries data={data} isLoading={isLoading} />}
			</Box>
		</AnalyticCard>
	);
};

export default GlobalStreams;
